"use client";

import { createContext, useContext, useState } from "react";

export type TranslationLink = { lang: string; href: string };

type LanguageSwitcherContextValue = {
  translatedUrls: TranslationLink[];
  setTranslatedUrls: (urls: TranslationLink[]) => void;
};

const LanguageSwitcherContext = createContext<LanguageSwitcherContextValue | null>(null);

export function LanguageSwitcherProvider({ children }: { children: React.ReactNode }) {
  const [translatedUrls, setTranslatedUrls] = useState<TranslationLink[]>([]);
  return (
    <LanguageSwitcherContext.Provider value={{ translatedUrls, setTranslatedUrls }}>
      {children}
    </LanguageSwitcherContext.Provider>
  );
}

export function useLanguageSwitcher(): LanguageSwitcherContextValue {
  const ctx = useContext(LanguageSwitcherContext);
  if (!ctx) {
    throw new Error("useLanguageSwitcher must be used within LanguageSwitcherProvider");
  }
  return ctx;
}
